// Ensure webpack processes the main scss file.
import './radio-interview-player.scss';

document.addEventListener( 'DOMContentLoaded', () => {

	document.querySelectorAll( '.rip-player' ).forEach( initPlayer );

} );

// =============================================================================
// Player initialisation
// =============================================================================

function initPlayer( player ) {

	const audio         = player.querySelector( '.rip-player__audio' );
	const playBtn       = player.querySelector( '.rip-player__btn--play' );
	const progressBar   = player.querySelector( '.rip-player__progress-bar' );
	const fill          = player.querySelector( '.rip-player__progress-fill' );
	const currentTime   = player.querySelector( '.rip-player__current-time' );
	const totalTime     = player.querySelector( '.rip-player__total-time' );
	const iconPlay      = playBtn.querySelector( '.icon-play' );
	const iconPause     = playBtn.querySelector( '.icon-pause' );
	const transcriptBtn = player.querySelector( '.rip-player__btn--transcript' );

	if ( ! audio ) return;

	// -------------------------------------------------------------------------
	// Play / pause
	// -------------------------------------------------------------------------

	playBtn.addEventListener( 'click', () => {
		if ( audio.paused ) {
			// Pause any other players on the page first.
			document.querySelectorAll( '.rip-player__audio' ).forEach( a => {
				if ( a !== audio && ! a.paused ) {
					a.pause();
					syncPlayState( a.closest( '.rip-player' ), a );
				}
			} );
			audio.play();
		} else {
			audio.pause();
		}
	} );

	audio.addEventListener( 'play',  () => syncPlayState( player, audio ) );
	audio.addEventListener( 'pause', () => syncPlayState( player, audio ) );
	audio.addEventListener( 'ended', () => {
		audio.currentTime = 0;
		syncPlayState( player, audio );
	} );

	// -------------------------------------------------------------------------
	// Progress
	// -------------------------------------------------------------------------

	audio.addEventListener( 'timeupdate', () => {
		if ( ! audio.duration ) return;
		const pct = ( audio.currentTime / audio.duration ) * 100;
		fill.style.width        = pct + '%';
		currentTime.textContent = formatTime( audio.currentTime );
		progressBar.setAttribute( 'aria-valuenow', Math.round( pct ) );
	} );

	audio.addEventListener( 'loadedmetadata', () => {
		totalTime.textContent = formatTime( audio.duration );
	} );

	// Click + drag on progress bar.
	let isDragging = false;

	function seek( e ) {
		const rect = progressBar.getBoundingClientRect();
		const x    = ( e.touches ? e.touches[0].clientX : e.clientX ) - rect.left;
		const pct  = Math.max( 0, Math.min( 1, x / rect.width ) );
		audio.currentTime = pct * audio.duration;
	}

	progressBar.addEventListener( 'mousedown',  e => { isDragging = true; seek( e ); } );
	progressBar.addEventListener( 'touchstart', e => { isDragging = true; seek( e ); }, { passive: true } );
	document.addEventListener( 'mousemove',  e => { if ( isDragging ) seek( e ); } );
	document.addEventListener( 'touchmove',  e => { if ( isDragging ) seek( e ); }, { passive: true } );
	document.addEventListener( 'mouseup',    () => { isDragging = false; } );
	document.addEventListener( 'touchend',   () => { isDragging = false; } );

	// Keyboard seek on progress bar (arrow keys).
	progressBar.addEventListener( 'keydown', e => {
		if ( ! audio.duration ) return;
		const step = 5; // seconds
		if ( e.key === 'ArrowRight' ) audio.currentTime = Math.min( audio.currentTime + step, audio.duration );
		if ( e.key === 'ArrowLeft'  ) audio.currentTime = Math.max( audio.currentTime - step, 0 );
	} );

	// -------------------------------------------------------------------------
	// Share dropdown
	// -------------------------------------------------------------------------

	initShareMenu( player );

	// -------------------------------------------------------------------------
	// Transcript toggle
	// -------------------------------------------------------------------------

	if ( transcriptBtn ) {
		const transcriptId = transcriptBtn.getAttribute( 'aria-controls' );
		const panel        = document.getElementById( transcriptId );

		if ( panel ) {
			transcriptBtn.addEventListener( 'click', () => {
				const isOpen = panel.classList.toggle( 'is-open' );
				transcriptBtn.setAttribute( 'aria-expanded', isOpen );
				panel.setAttribute( 'aria-hidden', ! isOpen );
			} );
		}
	}
}

// =============================================================================
// Share menu
// =============================================================================

function initShareMenu( player ) {
	const shareBtn  = player.querySelector( '.rip-player__btn--share' );
	if ( ! shareBtn ) return;

	const menuId    = shareBtn.getAttribute( 'aria-controls' );
	const menu      = document.getElementById( menuId );
	if ( ! menu ) return;

	const copyBtn   = menu.querySelector( '.rip-share-menu__item--copy' );

	// Toggle the menu open/closed.
	shareBtn.addEventListener( 'click', e => {
		e.stopPropagation();
		const isOpen = menu.classList.toggle( 'is-open' );
		shareBtn.setAttribute( 'aria-expanded', isOpen );
		menu.setAttribute( 'aria-hidden', ! isOpen );

		// Flip direction if the menu would overflow off-screen to the right.
		if ( isOpen ) {
			menu.classList.remove( 'rip-share-menu--right' );
			const rect = menu.getBoundingClientRect();
			if ( rect.right > window.innerWidth - 16 ) {
				menu.classList.add( 'rip-share-menu--right' );
			}
		}
	} );

	// Close on click outside.
	document.addEventListener( 'click', e => {
		if ( ! menu.contains( e.target ) && e.target !== shareBtn ) {
			closeMenu();
		}
	} );

	// Close on Escape.
	document.addEventListener( 'keydown', e => {
		if ( e.key === 'Escape' ) closeMenu();
	} );

	// Copy link button.
	if ( copyBtn ) {
		copyBtn.addEventListener( 'click', async () => {
			const url = copyBtn.dataset.copyUrl || window.location.href;
			try {
				await navigator.clipboard.writeText( url );
				const label = copyBtn.querySelector( 'span' );
				const original = label.textContent;
				label.textContent = 'Copied!';
				setTimeout( () => {
					label.textContent = original;
				}, 2000 );
			} catch ( err ) {
				// Clipboard not available — silently fail.
			}
		} );
	}

	function closeMenu() {
		menu.classList.remove( 'is-open' );
		shareBtn.setAttribute( 'aria-expanded', 'false' );
		menu.setAttribute( 'aria-hidden', 'true' );
	}
}

// =============================================================================
// Helpers
// =============================================================================

function syncPlayState( player, audio ) {
	const playBtn   = player.querySelector( '.rip-player__btn--play' );
	const iconPlay  = playBtn.querySelector( '.icon-play' );
	const iconPause = playBtn.querySelector( '.icon-pause' );
	const isPlaying = ! audio.paused && ! audio.ended;

	iconPlay.style.display  = isPlaying ? 'none'  : '';
	iconPause.style.display = isPlaying ? ''      : 'none';
	playBtn.setAttribute( 'aria-label', isPlaying ? 'Pause' : 'Play' );
}

function formatTime( seconds ) {
	if ( isNaN( seconds ) ) return '0:00';
	const m = Math.floor( seconds / 60 );
	const s = Math.floor( seconds % 60 );
	return m + ':' + String( s ).padStart( 2, '0' );
}